function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { archivedBackgroundUrl } from '@arc/frontend/ui-assets';
import { ButtonIconAdd } from '@arc/frontend/ui-buttons';
import { HubErrorBoundary } from '@arc/frontend/ui-common';
import { LoadingIndicator } from '@arc/frontend/ui-graphics';
import { theme, typography } from '@arc/frontend/ui-theme';
import { LinkIconAdd, LinkNavAction, useTableParams } from '@arc/frontend/util-router';
import { SidebarPagination } from './SidebarPagination';
const styles = {
  container: process.env.NODE_ENV === "production" ? {
    name: "186b4va",
    styles: "display:grid;height:100%;grid-template-columns:16rem calc(100% - 16rem);grid-template-rows:100%"
  } : {
    name: "ztr03g-container",
    styles: "display:grid;height:100%;grid-template-columns:16rem calc(100% - 16rem);grid-template-rows:100%;label:container;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  aside: /*#__PURE__*/css({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'auto',
    background: `linear-gradient(to right, ${theme.colors.background.default} 96%, ${theme.colors.gray[200]})`
  }, process.env.NODE_ENV === "production" ? "" : ";label:aside;"),
  titleContainer: /*#__PURE__*/css({
    backgroundColor: theme.colors.transparent,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '4rem',
    paddingLeft: '1rem',
    paddingRight: '1.25rem',
    paddingTop: '0.75rem',
    paddingBottom: '0.75rem'
  }, process.env.NODE_ENV === "production" ? "" : ";label:titleContainer;"),
  title: /*#__PURE__*/css(typography.title, {
    // Indicate when the title is a link.
    'a&': {
      color: theme.colors.text.tableHeader,
      cursor: 'pointer'
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:title;"),
  listItem: /*#__PURE__*/css("position:relative;display:flex;align-items:center;padding-left:1rem;padding-right:1rem;padding-top:0.75rem;padding-bottom:0.75rem;cursor:pointer;height:3.5rem;", typography.regular, process.env.NODE_ENV === "production" ? "" : ";label:listItem;"),
  listItemArchived: /*#__PURE__*/css({
    color: theme.colors.text.archivedRow,
    fontStyle: 'italic'
  }, process.env.NODE_ENV === "production" ? "" : ";label:listItemArchived;"),
  listItemSelected: /*#__PURE__*/css({
    background: theme.colors.background.form,
    boxShadow: '0px 0px 7px 6px #00000017',
    clipPath: 'inset(-3rem 0 -3rem 0)'
  }, process.env.NODE_ENV === "production" ? "" : ";label:listItemSelected;"),
  listItemSelectedArchived: process.env.NODE_ENV === "production" ? {
    name: "xgqlxg",
    styles: "background:#EEE"
  } : {
    name: "14ug34w-listItemSelectedArchived",
    styles: "background:#EEE;label:listItemSelectedArchived;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  listItemReadonly: /*#__PURE__*/css({
    color: theme.colors.text.note,
    fontWeight: 700,
    flexDirection: 'column',
    alignItems: 'normal',
    justifyContent: 'flex-start'
  }, process.env.NODE_ENV === "production" ? "" : ";label:listItemReadonly;"),
  listItemSelectedReadonly: /*#__PURE__*/css({
    background: theme.colors.background.form,
    boxShadow: '0px 0px 7px 6px #00000017',
    clipPath: 'inset(-3rem 0 -3rem 0)',
    color: theme.colors.text.note,
    fontWeight: 700,
    flexDirection: 'column',
    alignItems: 'normal',
    justifyContent: 'flex-start'
  }, process.env.NODE_ENV === "production" ? "" : ";label:listItemSelectedReadonly;"),
  main: /*#__PURE__*/css({
    height: '100%',
    backgroundColor: theme.colors.background.form
  }, process.env.NODE_ENV === "production" ? "" : ";label:main;"),
  mainArchived: /*#__PURE__*/css({
    backgroundColor: '#EEE',
    backgroundImage: `url('${archivedBackgroundUrl}')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center'
  }, process.env.NODE_ENV === "production" ? "" : ";label:mainArchived;")
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : {
  name: "1o8tj9x-SidebarView",
  styles: "display:flex;align-items:center;label:SidebarView;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "m1a2da",
  styles: "padding:0.5rem"
} : {
  name: "1pzb1ax-SidebarView",
  styles: "padding:0.5rem;label:SidebarView;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export function SidebarView({
  title,
  itemType,
  onClickAddButton,
  addButtonNavAction,
  listItemNavAction,
  titleNavAction,
  addButtonDisabled,
  list,
  readonlyText,
  selectedListItemIndex,
  subheader,
  filterButton,
  content,
  itemRenderer,
  listStyle,
  className,
  showPagination,
  totalRows,
  isSidebarLoading,
  selectedArchived
}) {
  const {
    currentPage,
    rowsPerPage,
    setCurrentPage,
    tableWrapRef
  } = useTableParams({
    itemType
  });
  return <div css={styles.container} className={className}>
			<aside css={styles.aside}>
				<div css={styles.titleContainer}>
					<div css={_ref}>
						{titleNavAction === undefined ? <p css={styles.title}>{title}</p> : <LinkNavAction css={styles.title} to={titleNavAction}>
								{title}
							</LinkNavAction>}
						{filterButton ? <div css={_ref2}>
								{filterButton}
							</div> : null}
					</div>
					{addButtonNavAction ? <LinkIconAdd to={addButtonNavAction} onClick={onClickAddButton} data-testid="sidebar-add-button" data-disabled={addButtonDisabled} /> : onClickAddButton ? <ButtonIconAdd onClick={onClickAddButton} data-testid="sidebar-add-button" data-disabled={addButtonDisabled} /> : null}
				</div>
				{subheader}
				<ul ref={tableWrapRef} css={["flex-grow:1;", listStyle, process.env.NODE_ENV === "production" ? "" : ";label:SidebarView;"]}>
					{list.length === 0 ? null : isSidebarLoading ? <LoadingIndicator /> : list.map(({
          key,
          value,
          archived = false,
          readonly = false
        }, index) => {
          const selected = index === selectedListItemIndex;
          return <li key={key || index}>
										<LinkNavAction css={[styles.listItem, readonly ? styles.listItemReadonly : null, archived ? styles.listItemArchived : null, selected ? styles.listItemSelected : null, selected && archived ? styles.listItemSelectedArchived : null, selected && readonly ? styles.listItemSelectedReadonly : null, process.env.NODE_ENV === "production" ? "" : ";label:SidebarView;"]} to={listItemNavAction(index)} data-testid="sidebar-list-item">
											{itemRenderer ? itemRenderer(key, value) : value ?? key}
											{readonly ? readonlyText : null}
										</LinkNavAction>
									</li>;
        })}
				</ul>

				{showPagination ? <SidebarPagination rowsPerPage={rowsPerPage ?? 0} totalItems={totalRows ?? 0} page={currentPage} onChangePage={setCurrentPage} isLoading={totalRows === undefined || totalRows === Infinity} /> : null}
			</aside>
			<main css={[styles.main, selectedArchived ? styles.mainArchived : null, process.env.NODE_ENV === "production" ? "" : ";label:SidebarView;"]}>
				<HubErrorBoundary>{content}</HubErrorBoundary>
			</main>
		</div>;
}